'use client';

import { BANKING_ASSESSMENT_FLOW_EXPERIMENT } from '@repo/absmartly/experiments';
import { FeatureViewed } from '@repo/segment/components/FeatureViewed';

type BankingAssessmentBannerControlTrackerProps = {
  slug: string;
};

export function BankingAssessmentBannerControlTracker({
  slug,
}: BankingAssessmentBannerControlTrackerProps) {
  const pageUrl = `/banking/best/${slug}`;

  if (!BANKING_ASSESSMENT_FLOW_EXPERIMENT.paths.includes(pageUrl)) {
    return null;
  }

  return (
    <FeatureViewed entityName="baf_control_banner" entitySection="banking">
      <div style={{ height: 0, overflow: 'hidden' }} />
    </FeatureViewed>
  );
}
